// import React, { useState } from "react";
// import {
//   Box,
//   Grid,
//   Paper,
//   Typography,
//   MenuItem,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   IconButton,
// } from "@mui/material";
// import trash from "../../../../assets/images/trash.svg";
// import eye from "../../../../assets/images/eye.svg";
// import Input from "../../../../components/Input";
// import ButtonComp from "../../../../components/Button";

// interface ServiceRow {
//   id: number;
//   service: string;
//   comment: string;
//   status: string;
// }

// export default function RequestServices({ onNext, onBack }: any) {
//   const [service, setService] = useState("");
//   const [comment, setComment] = useState("");
//   const [rows, setRows] = useState<ServiceRow[]>([]);

//   // 🔥 Add Service
//   const handleAdd = () => {
//     if (!service) return; // prevent empty service

//     const newRow: ServiceRow = {
//       id: Date.now(),
//       service,
//       comment,
//       status: "Added",
//     };

//     setRows((prev) => [...prev, newRow]);

//     // reset fields
//     setService("");
//     setComment("");
//   };

//   // 🔥 Delete Service
//   const handleDelete = (id: number) => {
//     setRows((prev) => prev.filter((row) => row.id !== id));
//   };

//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: 4,
//         mt: 3,
//         borderRadius: 3,
//         backgroundColor: "#fff",
//       }}
//     >
//       {/* Top Form Section */}
//       <Grid container spacing={3} alignItems="center">
//         <Grid size={{ xs: 12, md: 5 }}>
//           <Typography sx={{ mb: 1, fontSize: "18px", fontWeight: 600, textAlign:"left" }}>
//             Service
//           </Typography>

//           <Input
//             select
//             fullWidth
//             value={service}
//             onChange={(e: any) => setService(e.target.value)}
//           >
//             {[
//               "Body Removal",
//               "Burial Service",
//               "Catering",
//               "Transport",
//               "Mortuary",
//             ].map((item, index) => (
//               <MenuItem key={index} value={item}>
//                 {item}
//               </MenuItem>
//             ))}
//           </Input>
//         </Grid>

//         <Grid size={{ xs: 12, md: 5 }}>
//           <Typography sx={{ mb: 1, fontSize: "18px", fontWeight: 600, textAlign:"left" }}>
//             Comment or Description
//           </Typography>

//           <Input
//             fullWidth
//             value={comment}
//             onChange={(e: any) => setComment(e.target.value)}
//           />
//         </Grid>

//         <Grid size={{ xs: 12, md: 2 }}>
//           <Box mt={{ xs: 2, md: 4 }}>
//             <ButtonComp
//               variant="contained"
//               onClick={handleAdd}
//               sx={{
//                 backgroundColor: "#EF6C00",
//                 borderRadius: "30px",
//                 height: 50,
//                 width: "100%",
//                 fontWeight: 600,
//                 fontSize: 16,
//                 "&:hover": {
//                   backgroundColor: "#E65100",
//                 },
//               }}
//             >
//               ADD
//             </ButtonComp>
//           </Box>
//         </Grid>
//       </Grid>

//       {/* Table Section */}
//       <TableContainer
//         component={Paper}
//         elevation={0}
//         sx={{
//           mt: 4,
//           border: "1px solid #E5E7EB",
//         }}
//       >
//         <Table>
//           <TableHead sx={{ backgroundColor: "#F7F7F7" }}>
//             <TableRow>
//               <TableCell sx={{ fontWeight: 700 }}>
//                 Service Name
//               </TableCell>
//               <TableCell sx={{ fontWeight: 700 }}>
//                 Comment or Description
//               </TableCell>
//               <TableCell sx={{ fontWeight: 700 }}>
//                 Status
//               </TableCell>
//               <TableCell sx={{ fontWeight: 700 }}>
//                 Action
//               </TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody sx={{backgroundColor:"#ffffff"}}>
//             {rows.length === 0 ? (
//               <TableRow>
//                 <TableCell colSpan={4} align="center">
//                   No services added yet
//                 </TableCell>
//               </TableRow>
//             ) : (
//               rows.map((row) => (
//                 <TableRow
//                   key={row.id}
//                   sx={{
//                     "& td": {
//                       borderBottom: "1px solid #E5E7EB",
//                       py: 3,
//                     },
//                   }}
//                 >
//                   <TableCell>{row.service}</TableCell>
//                   <TableCell>{row.comment}</TableCell>
//                   <TableCell>{row.status}</TableCell>
//                   <TableCell>
//                     <IconButton>
//                       <img src={eye} alt="eye" />
//                     </IconButton>

//                     <IconButton onClick={() => handleDelete(row.id)}>
//                       <img src={trash} alt="trash" />
//                     </IconButton>
//                   </TableCell>
//                 </TableRow>
//               ))
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       {/* Bottom Buttons */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           mt: 6,
//         }}
//       >
//         <ButtonComp
//           variant="outlined"
//           onClick={onBack}
//           height={40}
//           width={190}
//         >
//           Back
//         </ButtonComp>

//         <ButtonComp
//           variant="contained"
//           onClick={onNext}
//           height={40}
//           width={190}
//           disabled={rows.length === 0}
//         >
//           NEXT
//         </ButtonComp>
//       </Box>
//     </Paper>
//   );
// }

import RequestedServicesForm from "../../components/forms/RequestedServicesForm";

export default function RequestedServices({ onNext, onBack }: any) {

  return (
    <RequestedServicesForm
      onBack={onBack}
      onNext={onNext}
    />
  );
}